// errors/BaseError.ts
var BaseError = class _BaseError extends Error {
  constructor(message, extensions = {}) {
    if (message instanceof _BaseError)
      return message;
    super(message instanceof Error ? message.message : message);
    this.extensions = extensions;
    if (message instanceof Error) {
      this.extensions.serverStack = message.stack;
      this.extensions.path = message.path;
    } else {
      if (!this.extensions.serverStack)
        this.extensions.serverStack = this.stack;
    }
    this.extensions._class = this._class;
  }
  static {
    this._class = "BaseError";
  }
  get _class() {
    return this.constructor._class;
  }
  static createFromDetails(message, extensions) {
    return new this(message, extensions);
  }
  toString() {
    return `Type: ${this._class}
Path: ${this.extensions.path?.join(" -> ") ?? "no path provided"}
Server stack: ${this.extensions.serverStack ?? "no server stack provided"}
Client stack: ${this.stack}`;
  }
  toJSON() {
    return { message: this.message, extensions: this.extensions, _class: this._class };
  }
};
export {
  BaseError
};
